var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sticky-download"},[_c('router-link',{attrs:{"to":"/download/"}},[_vm._v("⬇ Download GBWhatsApp APK")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }